/**
 * MIDIButtonWithPanel Component
 * Extracted from DAWWorkspace.jsx for better modularity
 * Handles MIDI device connection and panel display
 */

import { useRef } from 'react';
import { Button } from '../../ui/button';
import { Usb } from 'lucide-react';
import { MIDIDevicePanel } from '../MIDIDevicePanel';

export const MIDIButtonWithPanel = ({ midiDevices, showMIDIPanel, setShowMIDIPanel, midiActivity }) => {
  const buttonRef = useRef(null);
  
  return (
    <div className="relative">
      <Button
        ref={buttonRef}
        variant={midiDevices.hasAccess && midiDevices.isEnabled ? 'default' : 'ghost'}
        size="sm"
        onClick={() => {
          if (!midiDevices.hasAccess) {
            midiDevices.requestAccess();
          }
          setShowMIDIPanel(!showMIDIPanel);
        }}
        className={`relative p-2 ${
          midiDevices.hasAccess && midiDevices.isEnabled 
            ? 'bg-blue-500/20 text-blue-400 border border-blue-500/50' 
            : 'text-zinc-400 hover:text-white'
        }`}
        data-testid="midi-devices-toggle"
        title="External MIDI Devices"
      >
        <Usb className="w-5 h-5" />
        {midiActivity && (
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse" />
        )}
        {midiDevices.inputs.length > 0 && midiDevices.hasAccess && (
          <span className="absolute -bottom-1 -right-1 w-4 h-4 bg-blue-500 rounded-full text-[10px] flex items-center justify-center text-white font-bold">
            {midiDevices.inputs.length}
          </span>
        )}
      </Button>
      
      {/* MIDI Device Panel */}
      <MIDIDevicePanel
        isOpen={showMIDIPanel}
        onClose={() => setShowMIDIPanel(false)}
        isSupported={midiDevices.isSupported}
        hasAccess={midiDevices.hasAccess}
        isRequesting={midiDevices.isRequesting}
        error={midiDevices.error}
        inputs={midiDevices.inputs}
        selectedInputId={midiDevices.selectedInputId}
        isEnabled={midiDevices.isEnabled}
        onRequestAccess={midiDevices.requestAccess}
        onSelectInput={midiDevices.selectInput}
        onToggleEnabled={midiDevices.setMIDIEnabled}
        lastActivity={midiActivity}
        anchorRef={buttonRef}
      />
    </div>
  );
};

export default MIDIButtonWithPanel;
